import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import {
  TextAreaField, DEFAULT_REQUIRED_MESSAGE, DEFAULT_MIN_LENGTH_MESSAGE
} from 'common/components/form_fields';

const MIN_ANSWER_LENGTH = 150;

const WritingSamplesForm = ({error, handleSubmit, submitting, submitFailed, onCancel}) => (
  <form onSubmit={handleSubmit}>

    <fieldset>
      <Field name="favorite_company_name" label="1. What is your favorite company name and why do you think it's a strong name?" component={TextAreaField} rows={6} />
    </fieldset>
    <fieldset>
      <Field name="naming_experience" label="2. Describe your experience naming companies and/or products." component={TextAreaField} rows={6}/>
    </fieldset>
    <fieldset>
      <Field name="naming_process" label="3. Describe your process in helping clients name companies or products." component={TextAreaField} rows={6}/>
    </fieldset>
    <fieldset>
      <Field name="why_crowdspring" label="4. Why do you want to work on crowdspring in naming projects?" component={TextAreaField} rows={6}/>
    </fieldset>
    <fieldset>
      <Field name="favorite_tagline" label="5. What is your favorite tagline and why do you think it's a strong tagline?" component={TextAreaField} rows={6} />
    </fieldset>

    <div className="modal-actions">
      <AnimatedButton processing={submitting} type="submit" label="Done"
        baseBtnClass="btn-tertiary btn-block" processingLabel="Submitting..."
        errorMsg={error || submitFailed} successMsg="Submitted!"/>
      <button className="btn btn-text btn-block" onClick={(e) => {e.preventDefault(); onCancel();}}>
        Cancel
      </button>
    </div>

  </form>
)

const validate = values => {
  const errors = {};
  const fields = [
    'favorite_company_name', 'favorite_tagline', 'naming_experience', 'naming_process',
    'why_crowdspring'
  ];

  fields.forEach(f => {
    if (!values[f] || !values[f].trim()) {
      errors[f] = DEFAULT_REQUIRED_MESSAGE;
    } else if (values[f].trim().length < MIN_ANSWER_LENGTH) {
      errors[f] = DEFAULT_MIN_LENGTH_MESSAGE(MIN_ANSWER_LENGTH);
    }
  });

  return errors;
}

export default reduxForm({
  form: "WritingSamplesForm",
  validate,
})(WritingSamplesForm);



// WEBPACK FOOTER //
// ./registration/creative/components/writing_samples_form.jsx